import { render, staticRenderFns } from "./Signed.vue?vue&type=template&id=65b5980c&scoped=true"
import script from "./Signed.vue?vue&type=script&lang=js"
export * from "./Signed.vue?vue&type=script&lang=js"
import style0 from "./Signed.vue?vue&type=style&index=0&id=65b5980c&prod&lang=css"
import style1 from "./Signed.vue?vue&type=style&index=1&id=65b5980c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5980c",
  null
  
)

export default component.exports